import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  identity: [
    {
      value: null,
      placeholder: 'Category',
    },
    {
      value: null,
      placeholder: 'Month',
    },
    {
      value: null,
      placeholder: 'Day',
    },
    {
      value: null,
      placeholder: 'Year',
    },
  ],
  prediction: [
    {
      value: null,
      placeholder: 'Identity',
    },
    {
      value: null,
      placeholder: 'Event',
    },
    {
      value: null,
      placeholder: 'Trigger',
    },
    {
      value: null,
      placeholder: 'Prize',
    }
  ],
  rarity: 'Slot two or more cards'
}

export const craftingSlice = createSlice({
  name: 'crafting',
  initialState,
  reducers: {
    setCraftBlocks: (state, action) => {
      const { type, activeBlock, card, activeTag, cardRarity } = action.payload;
      if (type === 'identity') {
        state.identity = state.identity.map((item) => {
          return item.placeholder === activeBlock ? { ...item, value: { ...card,  tag: activeTag, rarity: cardRarity, } } : item
        })
      } else if (type === 'prediction') {
        state.prediction = state.prediction.map((item) => {
          return item.placeholder === activeBlock ? { ...item, value: { ...card, tag: activeTag, rarity: cardRarity } } : item
        })
      }
    },
    clearCraftBlock: (state, action) => {
      const { type, block } = action.payload;
      if (type === 'identity') {
        state.identity = state.identity.map((item) =>
          item.placeholder === block.placeholder ? { ...item, value: null } : item
        );
      } else if (type === 'prediction') {
        state.prediction = state.prediction.map((item) =>
          item.placeholder === block.placeholder ? { ...item, value: null } : item
        );
      }
    },
    clearCraftBlocks: (state, action) => {
      if (action.payload === 'identity') {
        state.identity = initialState.identity;
      } else if (action.payload === 'prediction') {
        state.prediction = initialState.prediction;
      }
    },
    setRarity: (state, action) => {
      state.rarity = action.payload
    }
  },
})

export const { setCraftBlocks, clearCraftBlock, clearCraftBlocks, setRarity } = craftingSlice.actions

export default craftingSlice.reducer;
